import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";

@Component({
  standalone: false,
  selector: "app-file-preview-fallback-modal",
  templateUrl: "./file-preview-fallback-modal.component.html",
  styleUrls: ["./file-preview-fallback-modal.component.scss"]
})
export class FilePreviewFallbackModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() fileName = "";

  @Output() isOpenChange = new EventEmitter<boolean>();
  @Output() confirmed = new EventEmitter<void>();

  submitting = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isOpen"] && this.isOpen) {
      this.submitting = false;
    }
  }

  confirm(): void {
    if (this.submitting) return;
    this.submitting = true;
    this.confirmed.emit();
    this.close();
  }

  close(): void {
    this.isOpen = false;
    this.isOpenChange.emit(false);
  }
}
